export enum WATERBODIES {
  LAKE = 'Lake',
  RIVER = 'River',
  WATER_ACCESS_SITE = 'Water Access Site',
}

export enum FISH_LAYERS {
  WATERBODY_SOURCE = 'lake:geometry',
  POI_SOURCE = 'lake:location',
  WATERBODY_LAYER = 'water-special',
  WATER_ACCESS_SOURCE = 'fish',
  WATER_ACCESS_SOURCE_LAYER = 'water_access_pois',
  FISHING_AREA_SOURCE_LAYER = 'fishing_areas',
  REGION = 'fishing_regions',
  REGION_LABEL = 'fishing_regions_label',
  EVENTS = 'fish_events',
  CATCH_POLYGON = 'fish_catches_cluster',
}

export enum XGPS_STYLESHEET_LAYER_ID {
  FISHING_AREAS_FILTERED = 'fhs_areas$fishing_areas_filtered',
  FISHING_AREAS_POINTS = 'fhs_areas$fishing_areas_points',
  FISHING_AREAS_NAMES = 'fhs_areas$fishing_areas_names',
  FISHING_AREAS_DOTS = 'fhs_areas$fishing_areas_dots',
  CATCH_DATA_FILL = 'fish_catch_cluster$fill',
  CATCH_DATA_BORDER = 'fish_catch_cluster$border',
  CATCH_DATA_BORDER_FILTERED = 'fish_catch_cluster$border_filtered',
}

export enum MODES {
  FRESHWATER = 'freshwater',
}

export const SUPPORTED_STATES = [
  'US-IA',
  'US-IL',
  'US-IN',
  'US-KS',
  'US-OH',
  'US-MI',
  'US-MN',
  'US-MO',
  'US-MT',
  'US-ND',
  'US-NE',
  'US-SD',
  'US-WI',
]

// Temp until data migration happens
export const tempFishMapping: Record<string, { name: string; slug: string }> = {
  'arctic-grayling': {
    name: 'Arctic grayling',
    slug: 'arctic-grayling',
  },
  'atlantic-salmon': {
    name: 'Atlantic salmon',
    slug: 'atlantic-salmon',
  },
  bass: {
    name: 'Bass',
    slug: 'bass',
  },
  'blue-catfish': {
    name: 'Blue catfish',
    slug: 'blue-catfish',
  },
  bluegill: {
    name: 'Bluegill',
    slug: 'bluegill',
  },
  'brook-trout': {
    name: 'Brook trout',
    slug: 'brook-trout',
  },
  'brown-trout': {
    name: 'Brown trout',
    slug: 'brown-trout',
  },
  lota: {
    name: 'Burbot',
    slug: 'lota',
  },
  burbot: {
    name: 'Burbot',
    slug: 'burbot',
  },
  catfish: {
    name: 'Catfish',
    slug: 'catfish',
  },
  'chain-pickerel': {
    name: 'Chain pickerel',
    slug: 'chain-pickerel',
  },
  'channel-catfish': {
    name: 'Channel catfish',
    slug: 'channel-catfish',
  },
  'chinook-salmon': {
    name: 'Chinook salmon',
    slug: 'chinook-salmon',
  },
  'chum-salmon': {
    name: 'Chum salmon',
    slug: 'chum-salmon',
  },
  'coho-salmon': {
    name: 'Coho salmon',
    slug: 'coho-salmon',
  },
  crappie: {
    name: 'Crappie',
    slug: 'crappie',
  },
  'cutthroat-trout': {
    name: 'Cutthroat trout',
    slug: 'cutthroat-trout',
  },
  'flathead-catfish': {
    name: 'Flathead catfish',
    slug: 'flathead-catfish',
  },
  'golden-trout': {
    name: 'Golden trout',
    slug: 'golden-trout',
  },
  'kokanee-salmon': {
    name: 'Kokanee salmon',
    slug: 'kokanee-salmon',
  },
  'lake-trout': {
    name: 'Lake trout',
    slug: 'lake-trout',
  },
  'largemouth-bass': {
    name: 'Largemouth bass',
    slug: 'largemouth-bass',
  },
  muskellunge: {
    name: 'Muskellunge',
    slug: 'muskellunge',
  },
  'northern-pike': {
    name: 'Northern pike',
    slug: 'northern-pike',
  },
  panfish: {
    name: 'Panfish',
    slug: 'panfish',
  },
  perch: {
    name: 'Perch',
    slug: 'perch',
  },
  pike: {
    name: 'Pike',
    slug: 'pike',
  },
  'pink-salmon': {
    name: 'Pink salmon',
    slug: 'pink-salmon',
  },
  pumpkinseed: {
    name: 'Pumpkinseed',
    slug: 'pumpkinseed',
  },
  'rainbow-trout': {
    name: 'Rainbow trout',
    slug: 'rainbow-trout',
  },
  'redeye-bass': {
    name: 'Redeye bass',
    slug: 'redeye-bass',
  },
  'rock-bass': {
    name: 'Rock bass',
    slug: 'rock-bass',
  },
  salmon: {
    name: 'Salmon',
    slug: 'salmon',
  },
  sauger: {
    name: 'Sauger',
    slug: 'sauger',
  },
  'shoal-bass': {
    name: 'Shoal bass',
    slug: 'shoal-bass',
  },
  'smallmouth-bass': {
    name: 'Smallmouth bass',
    slug: 'smallmouth-bass',
  },
  'sockeye-salmon': {
    name: 'Sockeye salmon',
    slug: 'sockeye-salmon',
  },
  'spotted-bass': {
    name: 'Spotted bass',
    slug: 'spotted-bass',
  },
  'striped-bass': {
    name: 'Striped Bass',
    slug: 'striped-bass',
  },
  sturgeon: {
    name: 'Sturgeon',
    slug: 'sturgeon',
  },
  acipenser: {
    name: 'Sturgeon',
    slug: 'acipenser',
  },
  'tiger-muskellunge': {
    name: 'Tiger muskellunge',
    slug: 'tiger-muskellunge',
  },
  trout: {
    name: 'Trout',
    slug: 'trout',
  },
  walleye: {
    name: 'Walleye',
    slug: 'walleye',
  },
  sander: {
    name: 'Walleye',
    slug: 'sander',
  },
  'white-bass': {
    name: 'White bass',
    slug: 'white-bass',
  },
  coregonus: {
    name: 'Whitefish',
    slug: 'coregonus',
  },
  whitefish: {
    name: 'Whitefish',
    slug: 'whitefish',
  },
  'yellow-bass': {
    name: 'Yellow Bass',
    slug: 'yellow-bass',
  },
}
